import { FormControl, Switch, TableCell } from "@mui/material";
import { TWTooltip } from "../../componentLibrary/TWTooltip/TWTooltip";

interface ShareTableCellProps {
  mealPlanTemplateId: string;
  isShared: boolean;
  updateIsShared: (mealPlanTemplateId: string, isShared: boolean) => void;
}

const ShareTableCell = ({ mealPlanTemplateId, isShared, updateIsShared }: ShareTableCellProps) => {
  return (
    <TableCell>
      <TWTooltip
        title={"Auto-onboarding"}
        subcopy="Enabling this will allow the athletes to choose this meal plan template as an option during the auto-onboarding process"
      >
        <FormControl>
          <Switch
            size="medium"
            inputProps={{
              "aria-label": "Auto-onboarding",
            }}
            checked={isShared}
            onClick={e => e.stopPropagation()}
            onChange={e => updateIsShared(mealPlanTemplateId, e.target.checked)}
          />
        </FormControl>
      </TWTooltip>
    </TableCell>
  );
};

export default ShareTableCell;
